/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../index';

/**
 * The schema for creating a draft from a schema.
 */
export interface MetaSchema {
    /** The schema of the draft. */
    schema: Truvity.ClaimsSchema;
    /** The slug of the draft. */
    slug?: string;
    /** The version of the draft. */
    version?: number;
}
